const dict = {
  uk: {
    you: 'Ви',
    teacher: 'Вчитель',
    participant: 'Учасник',
    muteMic: 'Вимкнути мікрофон',
    unmuteMic: 'Увімкнути мікрофон',
    muteCamera: 'Вимкнути камеру',
    unmuteCamera: 'Увімкнути камеру',
    stopScreenShare: 'Зупинити демонстрацію',
    startScreenShare: 'Демонструвати екран',
    micAlreadyOff: 'Мікрофон вже вимкнено',
    muteParticipantMic: 'Вимкнути мікрофон учаснику',
    cameraAlreadyOff: 'Камеру вже вимкнено',
    muteParticipantCamera: 'Вимкнути камеру учаснику',
    connecting: 'Підключення...',
    waiting: 'Очікування...',
    recording: 'Запис',
    recordingTitle: 'Заняття записується. Не закривайте вкладку до кінця уроку.',
  },
  en: {
    you: 'You',
    teacher: 'Teacher',
    participant: 'Participant',
    muteMic: 'Mute microphone',
    unmuteMic: 'Unmute microphone',
    muteCamera: 'Turn off camera',
    unmuteCamera: 'Turn on camera',
    stopScreenShare: 'Stop sharing',
    startScreenShare: 'Share screen',
    micAlreadyOff: 'Microphone is already muted',
    muteParticipantMic: 'Mute participant',
    cameraAlreadyOff: 'Camera is already off',
    muteParticipantCamera: 'Turn off participant camera',
    connecting: 'Connecting...',
    waiting: 'Waiting...',
    recording: 'Recording',
    recordingTitle: 'This lesson is being recorded. Keep this tab open until the lesson ends.',
  },
};

export default dict;
